import { useTeam } from 'app/frontend/base/config/context/team'
import { HTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'

export type OverviewTile = Omit<wowaudit.OverviewTile, 'id'> & {
  id?: number
  pending?: boolean
  _destroy?: boolean
  readonly?: boolean
}

export type TileProps = {
  tile: OverviewTile
  index: number
}

export type ConfigProps = {
  name: string
} & HTMLAttributes<HTMLDivElement>

export const newTile: OverviewTile = {
  type: 'Tile::CustomText',
  position: 'main',
  accessLevel: 'member',
  order: 0,
  pending: true,
  config: { title: '', text: '' },
}

export const useDefaultOverviewTiles = (): OverviewTile[] => {
  const { t } = useTranslation()
  const { team } = useTeam()

  return [
    {
      type: 'Tile::SidebarTiles',
      position: 'main',
      accessLevel: 'member',
      order: 0,
      config: {
        title: '',
        tile_1: 'Tile::UpcomingEvents',
        tile_2: 'Tile::EnchantAudit',
        tile_1_config: {
          title: t('overview.tiles.upcoming-events.default-title'),
          amount: 2,
        },
        tile_2_config: {
          title: t('overview.tiles.enchant-audit.default-title'),
          leniency: 'strict',
        },
      },
    },
    {
      type: 'Tile::RosterSummary',
      position: 'main',
      accessLevel: 'member',
      order: 1,
      config: { title: '', main_summary_type: 'by_role' },
    },
    {
      type: 'Tile::RecentNews',
      position: 'main',
      accessLevel: 'member',
      order: 2,
      config: { title: '' },
    },
    {
      type: 'Tile::TeamDescription',
      position: 'sidebar',
      accessLevel: 'member',
      order: 0,
      config: { title: team.ownerReference.name },
    },
    {
      type: 'Tile::PendingApplicants',
      position: 'sidebar',
      accessLevel: 'member',
      order: 1,
      config: {
        title: t('overview.tiles.pending-applicants.default-title'),
        amount: 10,
      },
    },
    {
      type: 'Tile::RosterSummary',
      position: 'sidebar',
      accessLevel: 'member',
      order: 2,
      config: { title: '', sidebar_summary_type: 'total_count' },
    },
  ]
}
